import React, { useState, useEffect, useContext } from "react";
import {
    Avatar,
    Button,
    DatePicker,
    List,
    Popover,
    Radio,
    Select,
    Typography,
} from "antd";
import moment from "moment";
import HTTP from "../../services/httpService";
import logoImage from "../../assets/images/aavgo-logo-dark.png";
import {
    disableFutureDates,
    formatDate,
    hotelTypeOptions,
} from "../../services/util";
import { useNavigate, useParams } from "react-router-dom";
import { SettingContext } from "../../routes";
import { ArrowLeftOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { LayoutContext } from "../../context/LayoutContext";

const { RangePicker } = DatePicker;
const { Option } = Select;

const mapSelection = [
    { title: "All Hotels", key: "total_hotel" },
    { title: "Hotel Address", key: "hotel_address" },
    { title: "Total Reservations", key: "checkin_count" },
    { title: "Total CheckIns", key: "total_checkin_new" },
    { title: "Total WalkIns", key: "walkin_count" },
    { title: "Total Scans", key: "scan_count" },
    { title: "Total Keys", key: "keys_count" },
    { title: "Total Cash Collected", key: "cash_collected" },
    { title: "Total Cash", key: "total_cash" },
    { title: "Total Cash Collected Transactions", key: "cash_collected_trans" },
    { title: "Total Cash Dispensed", key: "cash_dispence" },
    { title: "Total Cash Dispensed Transactions", key: "cash_dispenced_trans" },
    { title: "Total Calls", key: "calls_count" },
    { title: "Total Transactions", key: "transaction_count" },
    { title: "Total Housekeeping Tickets", key: "hk_ticket_count" },
    { title: "Total Housekeeping Orders", key: "hk_order_count" },
    { title: "Total Maintenance Tickets", key: "mnt_ticket_count" },
    { title: "Total Dinning Orders", key: "dinning_order_count" },
    { title: "Total Staff Sessions", key: "staff_user_count" },
    { title: "Total Guest Sessions", key: "guest_user_count" },
    { title: "Total IoS Sessions", key: "ios_user_count" },
    { title: "Total Andriod Sessions", key: "android_user_count" },
];

const kioskOptions = [
    { label: "All", value: "1" },
    { label: "Kiosk", value: "2" },
    { label: "Nexus", value: "3" },
];

function CustomHeader({ callDataAPI, extraAfter }) {
    const {
        selectedDates,
        setSelectedDates,
        selectedHotels,
        setSelectedHotels,
        loggedIn,
        singleSelectedHotels,
        setSingleSelectedHotels,
        selectedHotelType,
        setSelectedHotelType,
        kioskSelection,
        setKioskSelection,
        homeActiveTab,
    } = useContext(SettingContext);

    const tempSelectedHotelType = React.useRef(selectedHotelType);

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
            return null;
        }
    }, [loggedIn]);

    const drawerItem = [
        <div key="change-password">
            <Typography.Link strong onClick={handleChangePassword}>
                Change Password
            </Typography.Link>
        </div>,
        <div key="logout">
            <Typography.Link strong onClick={handleLogout}>
                Logout
            </Typography.Link>
        </div>,
    ];
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const user = localStorage.getItem(`userFirstname`);
    let showSelect = true;
    let showSingleSelect = false;
    let showRangePicker = true;
    let showCountsDropdown = false;
    let showHotelTypeSelection = false;
    let showCallTypeSelection = false;
    let showBackButton = true;
    const currentLocation = useLocation().pathname;
    let { hotel_id: urlHotelId } = useParams();

    if (currentLocation == "/") {
        showBackButton = false;
        showHotelTypeSelection = homeActiveTab != 3 ? true : false;
    }

    if (
        currentLocation.split("/").includes("average_reponse_time") ||
        currentLocation.split("/").includes("average_staff_reponse_time") ||
        currentLocation.split("/").includes("call-answered") ||
        currentLocation.split("/").includes("call-answered-details") ||
        currentLocation.split("/").includes("call-missed") ||
        currentLocation.split("/").includes("call-missed-details") ||
        currentLocation.split("/").includes("total-time-duration") ||
        currentLocation.split("/").includes("reviews-table") ||
        currentLocation.split("/").includes("transaction-duration-table") ||
        currentLocation.split("/").includes("scan-details-table") ||
        currentLocation.split("/").includes("new-call-details") ||
        (currentLocation.split("/").includes("sent_receipt") && !urlHotelId) ||
        (selectedHotelType == "kiosk" &&
            (currentLocation == "/" ||
                currentLocation.split("/").includes("details")))
    ) {
        showCallTypeSelection = true;
    }

    if (
        currentLocation.split("/").includes("category") ||
        currentLocation.split("/").includes("call-time") ||
        currentLocation.split("/").includes("tickets") ||
        currentLocation.split("/").includes("git-dashboard") ||
        currentLocation.split("/").includes("operation-details") ||
        currentLocation.split("/").includes("hotel-counts") ||
        currentLocation.split("/").includes("hubSpot-details-table") ||
        currentLocation.split("/").includes("ticket-form") ||
        currentLocation.split("/").includes("build-upload") ||
        currentLocation.split("/").includes("queue-instances") ||
        currentLocation.split("/").includes("server-instances") ||
        currentLocation.split("/").includes("jira-dashboard") ||
        currentLocation.split("/").includes("Expenditure") ||
        currentLocation.split("/").includes("upcoming-hotels") ||
        currentLocation.split("/").includes("users") ||
        currentLocation.split("/").includes("report-settings") ||
        currentLocation.split("/").includes("alarms") ||
        currentLocation.split("/").includes("kiosk-properties") ||
        currentLocation.split("/").includes("vendors") ||
        currentLocation.split("/").includes("restart-history") ||
        currentLocation.split("/").includes("alarms") ||
        currentLocation.split("/").includes("report-settings") ||
        currentLocation.split("/").includes("team-manangement") ||
        currentLocation.split("/").includes("sprint-analytics") ||
        currentLocation.split("/").includes("rooms") ||
        currentLocation.split("/").includes("business-analytics") ||
        currentLocation.split("/").includes("contacts") ||
        (currentLocation == "/" && homeActiveTab == 3)
    ) {
        showSelect = false;
        showRangePicker = false;
    } else if (
        currentLocation.split("/").includes("calls") ||
        currentLocation.split("/").includes("analytics") ||
        currentLocation.split("/").includes("jira-dashboard") ||
        currentLocation.split("/").includes("tickets-chart") ||
        currentLocation.split("/").includes("hotel-dashboard") ||
        currentLocation.split("/").includes("call-answered-details") ||
        currentLocation.split("/").includes("call-missed-details") ||
        currentLocation.split("/").includes("average_staff_reponse_time") ||
        (currentLocation.split("/").includes("shift_notes") && urlHotelId) ||
        (currentLocation.split("/").includes("sent_receipt") && urlHotelId) ||
        (currentLocation.split("/").includes("call-log") && urlHotelId) 
    ) {
        showSelect = false;
    } else if (currentLocation.split("/").includes("map")) {
        showCountsDropdown = true;
        showSelect = false;
    } else if (
        currentLocation.split("/").includes("transaction-duration-graph") ||
        currentLocation.split("/").includes("reviews-graph")
    ) {
        showSelect = false;
        showSingleSelect = true;
    } else if (
        currentLocation.split("/").includes("details") ||
        currentLocation.split("/").includes("support-details-table")
    ) {
        showHotelTypeSelection = true;
    } else if (
        currentLocation.split("/").includes("demographic-analytics") ||
        currentLocation.split("/").includes("reservation-analytics") ||
        currentLocation.split("/").includes("maintenance-analytics") ||
        currentLocation.split("/").includes("housekeeping-analytics")
    ) {
        showRangePicker = false;
    } else if (
        currentLocation.split("/").includes("support-analytics") ||
        currentLocation.split("/").includes("hotels")
    ) {
        showSelect = false;
    }
    const navigate = useNavigate();

    const { setCollapsed, isMobile } = useContext(LayoutContext);
    const [hotelListOptions, setHotelListOptions] = useState([]);
    const [mapDataKey, setMapDataKey] = useState("total_hotel");
    const [avatarContentVisible, setAvatarContentVisible] = useState(false);

    const [formData, setFormData] = useState({
        staff_id,
        hotel_type: selectedHotelType,
    });
    const {
        status: initailDataStataus,
        data: initialData,
        refetch: getInitialData,
    } = useQuery(
        "initialData",
        async () => {
            return await HTTP("/users/getInitData", formData);
        },
        { enabled: false },
    );

    const {
        status,
        data,
        refetch: getHotels,
    } = useQuery(
        "hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", formData);
        },
        { enabled: false },
    );
    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
            return null;
        }

        getHotels();
        if (currentLocation === "/") {
            getInitialData();
        }
    }, []);

    useEffect(() => {
        getHotels();
    }, [formData]);

    useEffect(() => {
        if (tempSelectedHotelType.current != selectedHotelType) {
            setFormData({
                ...formData,
                hotel_type: selectedHotelType,
                hotel_ids: [],
                all_selected: true,
            });
            setSelectedHotels([]);
        } else {
            tempSelectedHotelType.current = selectedHotelType;
        }
    }, [selectedHotelType]);

    useEffect(() => {
        if (status === "success") {
            setHotelListOptions(data.data);
            if (
                currentLocation
                    .split("/")
                    .includes("transaction-duration-graph") ||
                currentLocation.split("/").includes("reviews-graph")
            ) {
                const hotelToBeSelected = data.data.find(
                    (e) => e.hotel_id === parseInt(urlHotelId),
                );
                if (hotelToBeSelected) {
                    setSingleSelectedHotels(
                        `${hotelToBeSelected.hotel_name}#${hotelToBeSelected.hotel_id}`,
                    );
                }
            }
        }
    }, [status, data]);

    function handleDateChange(e) {
        let start_date =
            e !== null ? moment(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? moment(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        const formData = { start_date, end_date, hotel_ids: [] };
        if (currentLocation.split("/").includes("map")) {
            formData.data_for = mapDataKey;
        } else {
            let hotel_ids;
            if (
                currentLocation
                    .split("/")
                    .includes("transaction-duration-graph") ||
                currentLocation.split("/").includes("reviews-graph")
            ) {
                hotel_ids = [singleSelectedHotels.split("#")[1]];
            } else {
                hotel_ids = selectedHotels;
            }
            formData.hotel_ids = hotel_ids;
        }
        formData.all_selected = formData.hotel_ids.length > 0 ? false : true;
        if (callDataAPI) callDataAPI(formData);
    }

    function handleSelectChange(e) {
        const hotel_ids = e;
        setSelectedHotels(e);
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        const formData = {
            start_date,
            end_date,
            hotel_ids,
        };
        formData.all_selected = hotel_ids.length > 0 ? false : true;
        if (callDataAPI) callDataAPI(formData);
    }

    function redirectHome() {
        navigate(`/`);
    }

    async function handleLogout() {
        const { success } = await HTTP("/users/logout", { staff_id });
        if (success) {
            localStorage.clear();
            window.location.reload();
        }
    }

    function handleMapSelectionChange(e) {
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        setMapDataKey(e.trim());
        const formData = {
            start_date,
            end_date,
            all_selected: true,
            hotel_ids: [],
            data_for: e.trim(),
        };
        callDataAPI(formData);
    }

    function handleSingleSelectChange(e) {
        let hotel_ids = [];
        if (e) {
            [, hotel_ids] = e.split("#");
        }
        setSingleSelectedHotels(e);
        const start_date = formatDate(selectedDates[0]);
        const end_date = formatDate(selectedDates[1]);
        const formData = {
            start_date,
            end_date,
            hotel_ids,
        };
        formData.all_selected = false;
        if (callDataAPI) callDataAPI(formData);
    }

    function handleAvatarVisible(visible) {
        setAvatarContentVisible(visible);
    }

    function handleChangePassword() {
        navigate("/change-password");
    }

    function handleHotelTypeSelection(e) {
        setSelectedHotelType(e);
    }

    return (
        <div className="dashboard-search-filter">
            {isMobile && (
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "start",
                    }}
                >
                    <MenuUnfoldOutlined onClick={() => setCollapsed(false)} />
                </div>
            )}
            <div className="logo">
                <img
                    src={logoImage}
                    alt="AavGo"
                    onClick={redirectHome}
                    className="logo-image"
                />
            </div>
            {showCallTypeSelection && (
                <Radio.Group
                    options={kioskOptions}
                    onChange={(e) => {
                        setKioskSelection(e.target.value);
                    }}
                    value={kioskSelection}
                    optionType="button"
                    className=" select-container kiosk-type-selection"
                    buttonStyle="solid"
                />
            )}
            {showHotelTypeSelection ? (
                <Select
                    defaultValue={selectedHotelType}
                    value={selectedHotelType}
                    allowClear={false}
                    className="select-container margin-right-5 width-13"
                    placeholder="Select Hotel Type"
                    onChange={handleHotelTypeSelection}
                >
                    {hotelTypeOptions.map((e) => (
                        <Option key={e.key}>{e.title}</Option>
                    ))}
                </Select>
            ) : null}

            {showSelect ? (
                <Select
                    defaultValue={selectedHotels}
                    value={selectedHotels}
                    showSearch
                    mode="multiple"
                    allowClear
                    className="select-container margin-right-5"
                    placeholder="Hotel Name"
                    filterOption={(input, option) =>
                        option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    onChange={handleSelectChange}
                    loading={hotelListOptions.length === 0 ? true : false}
                >
                    {hotelListOptions.map((option) => (
                        <Option key={option.hotel_id} value={option.hotel_id}>
                            {`${option.hotel_id} - ${option.hotel_name} - ${option.city}`}
                        </Option>
                    ))}
                </Select>
            ) : null}

            {showSingleSelect ? (
                <Select
                    defaultValue={singleSelectedHotels}
                    showSearch
                    className="select-container"
                    placeholder="Hotel Name"
                    allowClear
                    onChange={handleSingleSelectChange}
                    loading={hotelListOptions.length === 0 ? true : false}
                >
                    {hotelListOptions.map((option) => (
                        <Option key={`${option.hotel_name}#${option.hotel_id}`}>
                            {`${option.hotel_id} - ${option.hotel_name}`}
                        </Option>
                    ))}
                </Select>
            ) : null}

            {showCountsDropdown ? (
                <Select
                    defaultValue={"total_hotel"}
                    showSearch
                    allowClear={false}
                    className="select-container margin-right-5"
                    placeholder="Select field"
                    onChange={handleMapSelectionChange}
                    loading={hotelListOptions.length === 0 ? true : false}
                >
                    {mapSelection.map((option) => (
                        <Option key={`${option.key}`}>{option.title}</Option>
                    ))}
                </Select>
            ) : null}

            {showRangePicker ? (
                <RangePicker
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    defaultValue={[
                        moment(selectedDates[0]),
                        moment(selectedDates[1]),
                    ]}
                    value={[moment(selectedDates[0]), moment(selectedDates[1])]}
                    className="dashboard-date-search margin-right-5 select-container"
                    onChange={handleDateChange}
                    format="MM/DD/YYYY"
                    ranges={{
                        Today: [moment(), moment()],
                        Yesterday: [
                            moment().subtract(1, "day"),
                            moment().subtract(1, "day"),
                        ],
                        "Last 7 Days": [moment().subtract(7, "day"), moment()],
                        "Last 30 Days": [
                            moment().subtract(29, "day"),
                            moment(),
                        ],
                        "Current Month": [moment().startOf("month"), moment()],
                        "Last Month": [
                            moment().subtract(1, "month").startOf("month"),
                            moment().subtract(1, "month").endOf("month"),
                        ],
                        "Last 3 Month": [
                            moment().subtract(3, "month"),
                            moment(),
                        ],
                    }}
                />
            ) : null}

            {extraAfter ?? ""}
            <div className="icon-container">
                {showBackButton ? (
                    <Button
                        className="margin-right-5"
                        type="primary"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        <ArrowLeftOutlined /> Back
                    </Button>
                ) : null}
                <Popover
                    overlayStyle={{
                        width: "10vw",
                    }}
                    placement="bottom"
                    content={
                        <List
                            dataSource={drawerItem}
                            renderItem={(item) => item}
                        />
                    }
                    trigger="click"
                    open={avatarContentVisible}
                    onOpenChange={handleAvatarVisible}
                >
                    <Avatar
                        style={{
                            backgroundColor: "#7c38a1",
                            verticalAlign: "middle",
                            // marginLeft: "10px",
                        }}
                        size="default"
                    >
                        {user ? user.substring(0, 1).toUpperCase() : "U"}
                    </Avatar>
                </Popover>
            </div>
        </div>
    );
}

export default CustomHeader;
